import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import './RoomsManager.css';

const RoomsVisualList = (props) => {
  const { roomsList, showIcon } = props;

  const customListClass = `data-list__container ${(showIcon) ? 'icon-split' : ''}`;

  const getRoomDataLabel = (room) => {
    const { code, name } = room;

    const roomData = (name) ? name : code;

    return `${(roomData === '') ? translate('habitacionNoSeleccionada') : roomData}`;
  };

  const getRoomCountIndicator = (room) => {
    const { count } = room;

    if (!count) return <></>;

    if (count <= 1) return <></>;

    return (
      <div className="count-indicator">
        <span className="room-indicator">
          {count}
        </span>
      </div>
    );
  };

  return (
    <Row className="auto-margin rooms-visual-list__container">
      {(showIcon) &&
        <Col sm="auto" className="icon__container">
          <i className="fas fa-bed"></i>
        </Col>
      }
      <Col className={customListClass}>
        <Row className="auto-margin">
          {
            roomsList.map((room, index) => {
              const customKey = `VISUAL-ROOM-${index}`;
              const dataTestLabel = `room-data-${index}`;

              return (
                <Col key={customKey} sm="12" className="room-info-item" data-test-label={dataTestLabel}>
                  <div className="room-data">
                    {getRoomDataLabel(room)}
                  </div>
                  {getRoomCountIndicator(room)}
                </Col>
              );
            })
          }
        </Row>
      </Col>
    </Row>
  );
};

RoomsVisualList.propTypes = {
  roomsList: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    count: PropTypes.number
  })),
  showIcon: PropTypes.bool
};

RoomsVisualList.defaultProps = {
  roomsList: [],
  showIcon: false
};

export default RoomsVisualList;
